import React, { useEffect, useRef } from "react";
import { SortOverlay, SortDropdownPanel, OptionItem } from "./index.styles";

import { ReactComponent as CheckIcon } from "../../../newLayout/assets/svgIcon/listView/check.svg";

// ---------------------------------------------------------------------------
// SORT_OPTIONS config
// ---------------------------------------------------------------------------
export const SORT_DIRECTIONS = {
  ASC: "Ascending",
  DESC: "Descending",
};

/**
 * SortDropdown
 *
 * Props:
 *  - isOpen       : boolean
 *  - onClose      : () => void
 *  - sortKey      : string  — the API field name, e.g. "display_name"
 *  - activeOrdering : string | null  — current ?ordering= value in params
 *  - onSort       : (ordering: string | null) => void
 *                   null → reset (remove ordering key)
 */
const SortDropdown = ({ isOpen, onClose, sortKey, activeOrdering, onSort }) => {
  const panelRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const ascValue = sortKey;
  const descValue = `-${sortKey}`;

  const handleSelect = direction => {
    const value = direction === SORT_DIRECTIONS.ASC ? ascValue : descValue;
    onSort(value);
    onClose();
  };

  const handleReset = () => {
    onSort(null);
    onClose();
  };

  return (
    <>
      <SortOverlay onClick={onClose} />
      <SortDropdownPanel ref={panelRef}>
        <OptionItem
          className={activeOrdering === ascValue ? "active" : ""}
          onClick={() => handleSelect(SORT_DIRECTIONS.ASC)}
        >
          Ascending
          {activeOrdering === ascValue && <CheckIcon />}
        </OptionItem>
        <OptionItem
          className={activeOrdering === descValue ? "active" : ""}
          onClick={() => handleSelect(SORT_DIRECTIONS.DESC)}
        >
          Descending
          {activeOrdering === descValue && <CheckIcon />}
        </OptionItem>
        <OptionItem className="reset" onClick={handleReset}>
          Reset
        </OptionItem>
      </SortDropdownPanel>
    </>
  );
};

export default SortDropdown;
